var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.orderInfoData
    ? _c(
        "div",
        [
          _c(
            "el-card",
            [
              _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                _c("span", [_vm._v("投保信息")]),
                _c(
                  "span",
                  { staticStyle: { float: "right", "font-weight": "bold" } },
                  [
                    _vm._v("\n\t\t\t\t保费合计：\n\t\t\t\t"),
                    _c(
                      "span",
                      {
                        staticClass: "red-bold",
                        staticStyle: { "font-size": "1.26em" },
                      },
                      [_vm._v(_vm._s(_vm.orderInfoData.totalPremium))]
                    ),
                    _vm._v("\n\t\t\t\t元\n\t\t\t"),
                  ]
                ),
              ]),
              [
                !_vm.isMore
                  ? _c("div", [
                      _vm._v(
                        "\n\t\t\t\t" + _vm._s(_vm.getUnitTitle) + "\n\t\t\t\t"
                      ),
                      _c("span", { staticClass: "u-font-weight-bold" }, [
                        _vm._v(_vm._s(_vm.unitName)),
                      ]),
                    ])
                  : _vm._e(),
                _c("div", { staticStyle: { margin: "2px 0" } }, [
                  _vm._v("\n\t\t\t\t保障时间：\n\t\t\t\t"),
                  _c("span", { staticClass: "red-bold" }, [
                    _vm._v(_vm._s(_vm.orderInfoData.effectiveDate)),
                  ]),
                  _vm._v("\n\t\t\t\t至\n\t\t\t\t"),
                  _c("span", { staticClass: "red-bold" }, [
                    _vm._v(_vm._s(_vm.orderInfoData.expiryDate)),
                  ]),
                ]),
                !_vm.isAdd
                  ? _c("div", { staticStyle: { "margin-bottom": "10px" } }, [
                      _vm._v("\n\t\t\t\t保障期限：\n\t\t\t\t"),
                      _c("span", { staticClass: "red-bold" }, [
                        _vm._v(_vm._s(_vm.getTermContent)),
                      ]),
                    ])
                  : _c("div", { staticStyle: { "margin-bottom": "10px" } }, [
                      _vm._v("\n\t\t\t\t保障天数：\n\t\t\t\t"),
                      _c("span", { staticClass: "red-bold" }, [
                        _vm._v(_vm._s(_vm.orderInfoData.periodDay) + " 天"),
                      ]),
                    ]),
              ],
              _c("avue-crud", {
                ref: "refInfo",
                attrs: { data: _vm.empsData, option: _vm.confirmOption },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "professionId",
                      fn: function (ref) {
                        var row = ref.row
                        return [
                          _c("span", [_vm._v(_vm._s(row.professionName))]),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  2890590917
                ),
              }),
            ],
            2
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }